import { Reimbursement } from '~libs.shared.prescription';

export type OnReimbursementClick = (reimbursement: Reimbursement) => void;

export enum ReimbursementVariant {
   PRIMARY,
   STANDARD,
}
